import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import BaseLayer from "../core/BaseLayer";
import EarthAtomSphereModel from "./models/atmosphere";
import BaseEarthModel from "./models/base";
import EarthBloomSphereModel from "./models/bloomsphere";
const EarthModels = {
  base: BaseEarthModel,
  atomSphere: EarthAtomSphereModel,
  bloomSphere: EarthBloomSphereModel
};
const earthLayerTypes = ['base', 'atomSphere', 'bloomSphere'];
export default class EarthLayer extends BaseLayer {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "type", 'EarthLayer');
    _defineProperty(this, "defaultSourceConfig", {
      data: [],
      options: {
        parser: {
          type: 'json'
        }
      }
    });
  }
  buildModels() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const shape = _this.getModelType();
      _this.layerModel = new EarthModels[shape](_this);
      yield _this.initLayerModels();
    })();
  }

  /**
   * 设置当前地球时间
   * @param time
   */
  setEarthTime(time) {
    if (this.layerModel && this.layerModel.setEarthTime) {
      this.layerModel.setEarthTime(time);
    } else {
      console.warn('请在 scene loaded 之后执行该方法！');
    }
  }
  getModelType() {
    var _shapeAttribute$scale;
    const shapeAttribute = this.styleAttributeService.getLayerStyleAttribute('shape');
    let shape = (shapeAttribute === null || shapeAttribute === void 0 || (_shapeAttribute$scale = shapeAttribute.scale) === null || _shapeAttribute$scale === void 0 ? void 0 : _shapeAttribute$scale.field) || 'base';
    if (earthLayerTypes.indexOf(shape) < 0) {
      shape = 'base';
    }
    return shape;
  }
}